import React, { memo } from "react";
import Region from "./region";
import Contact from "./contact";
import BasicInformation from "./basicInformation";
import AdditionalInformation from "./additionalInformation";
import Specializations from "./specializations";

const AllSteps = ({ id, onNext }) => {
    const stepsComponent = {
        0: <Contact />,
        1: <BasicInformation />,
        2: <Region />,
        3: <AdditionalInformation onNext={onNext} />,
        4: <Specializations />,

    };

    return stepsComponent[id];
};

export default memo(AllSteps);
